var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('modal-edit-location',{ref:"ModalEditLocation"}),_c('modal-select-location',{ref:"ModalSelectLocation"}),_c('modal-add-location',{ref:"ModalAddLocation"}),_c('modal-enter-location',{ref:"ModalEnterLocation"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }